import {SendEmailPortModel} from '@/components/Canvas/customNodes/SendEmail/SendEmailPortModel'
import {setInitialNodeSendNotificationData} from '@ReduxActions'
import {PortModelAlignment} from '@projectstorm/react-diagrams'
import {store} from '../../../../store'
import {NodeTypeEnum} from '../../../../types/NodeTypeEnum'
import {removeNodeAndConnectItsParentAndTarget} from '../../utils/NodeEventUtils'
import {CustomNodeModel} from '../CustomNodeModel'

// this can be further extended for more complicated node types
export class SendEmailNodeModel extends CustomNodeModel {
  constructor(id?: string) {
    const obj = {
      type: NodeTypeEnum.sendEmail,
      id,
      extras: {
        name: 'Send Email',
        priority: 4,
        nodeSize: 250,
      },
    }
    if (!id) delete obj.id

    super(obj)

    this.addPort(new SendEmailPortModel(PortModelAlignment.TOP))
    this.addPort(new SendEmailPortModel(PortModelAlignment.BOTTOM))

    store.dispatch(
      setInitialNodeSendNotificationData({
        id: this.getID(),
        type: NodeTypeEnum.sendEmail,
      })
    )
  }

  remove() {
    removeNodeAndConnectItsParentAndTarget(this.getID(), () => super.remove())
  }
}
